import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'MovePageBtn',
  props: {
    routeName: {},
    title: {},
    class: { default: '' },
    color: { default: '' },
    style: { default: undefined },
    disabled: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: true },
    isMovable: { type: Boolean, default: true }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const router = useRouter()

const isClicked = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})

function movePage() {
  isClicked.value = true;
  if (!props.isMovable) {
    return
  }
  router.push({ name: props.routeName });
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    class: _normalizeClass(props.class),
    color: props.color,
    style: _normalizeStyle(props.style),
    disabled: props.disabled,
    onClick: movePage
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.title), 1)
    ]),
    _: 1
  }, 8, ["class", "color", "style", "disabled"]))
}
}

})